import React from 'react';
import { IconType } from 'react-icons';

interface IconProps {
    icon: IconType;
    size?: number;
}

const IconComponent: React.FC<IconProps> = ({ icon, size = 20 }) => {
    const Icon = icon as React.ComponentType<{ size?: number }>;
    return (
        <div>
            {React.createElement(Icon, { size })}
        </div>
    );
};

export default IconComponent;